import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const clientMetadataService = { getClientMetadata, upsertClientMetadata }

const API_URL = API.BASE_URL + '/v1'

export function getClientMetadata(accountNo) {
  return apiHelper(API_URL).get(`/client-metadata/${accountNo}`)
}
export function upsertClientMetadata(data) {
  return apiHelper(API_URL).post('/client-metadata', data)
}
